/**
* Glossary JS
* -----------------------------------------------------------------------------
*
* All the JS for the Glossary component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'glossary',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      mobileDropdown();
      $( window ).on( 'resize', function() {
        mobileDropdown();
      } );
      function mobileDropdown() {
        if ( window.innerWidth < 768 ) {
          let open = false;
          $( '.mobile-dropdown' ).on( 'click', function() {
            if ( open === false ) {
              $( this ).addClass( 'active' );
              open = true;
            } else if ( open === true ) {
              $( '.mobile-dropdown' ).removeClass( 'active' );
              open = false;
            }
          } );
        }
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'glossary', COMPONENT );
} )( app );
